module.exports = __webpack_public_path__ + "img/handraw_boite iso.74c9bf24.svg";